import VideoThumbnail from '@/data/VideoThumbnail';

export default class Video {
  private _id: string;
  private _title: string | undefined;
  private _desc: string | undefined;
  private _thumbnailUrl: string | undefined;
  private _length: number | undefined;
  private _createdDate: number | undefined;
  private _modifiedDate: number | undefined;
  private _uploadDate: number | undefined;
  private _publicationDate: number | undefined;
  private _plays: number | undefined;
  private _views: number | undefined;
  private _channels = new Array<number>();
  private _customMetaData = new Map<string, string>();
  private _keywords: Array<string> = [];
  private _thumbnails: Promise<Array<VideoThumbnail>|undefined> | undefined;
  private _posterUrl: string | undefined;
  private _priority: number | undefined;
  
  constructor(id: string) {
    this._id = id;
  }
  public get id() {
    return this._id;
  }
  public get title() {
    return this._title;
  }
  public set title(value) {
    this._title = value;
  }
  public get desc() {
    return this._desc;
  }
  public set desc(value) {
    this._desc = value;
  }
  public get thumbnailUrl() {
    return this._thumbnailUrl;
  }
  public set thumbnailUrl(value) {
    this._thumbnailUrl = value;
  }
  public get length() {
    return this._length;
  }
  public set length(value) {
    this._length = value;
  }
  public get createdDate() {
    return this._createdDate;
  }
  public set createdDate(value) {
    this._createdDate = value;
  }
  public get modifiedDate() {
    return this._modifiedDate;
  }
  public set modifiedDate(value) {
    this._modifiedDate = value;
  }
  public get uploadDate() {
    return this._uploadDate;
  }
  public set uploadDate(value) {
    this._uploadDate = value;
  }
  public get publicationDate() {
    return this._publicationDate;
  }
  public set publicationDate(value) {
    this._publicationDate = value;
  }
  public get plays() {
    return this._plays;
  }
  public set plays(value) {
    this._plays = value;
  }
  public get views() {
    return this._views;
  }
  public set views(value) {
    this._views = value;
  }
  public get channels() {
    return this._channels;
  }
  public get customMetaData() {
    return this._customMetaData;
  }
  public get keywords() {
    return this._keywords;
  }
  public set keywords(value) {
    this._keywords = value;
  }
  public get thumbnails() {
    return this._thumbnails;
  }
  public set thumbnails(value) {
    this._thumbnails = value;
  }
  public get posterUrl() {
    return this._posterUrl;
  }
  public set posterUrl(value) {
    this._posterUrl = value;
  }
  public get priority() {
    return this._priority;
  }
  public set priority(value) {
    this._priority = value;
  }
}